import React, { useState } from "react";
import "./App.css";

export default function Prac() {
  const [lists, setList] = useState([
    { id: 1, title: "리액트 공부하기", contents: "챕터1 완료", isDone: false },
    { id: 2, title: "리액트 공부하기", contents: "챕터2 완료", isDone: false },
    { id: 3, title: "리액트 공부하기", contents: "챕터3 완료", isDone: false },
  ]);

  const [title, setTitle] = useState("");
  const [contents, setContents] = useState("");

  function onChangeNameHandler(e) {
    setTitle(e.target.value);
  }
  function onChangeContentsHandler(e) {
    setContents(e.target.value);
  }

  function addToDo() {
    setList([
      ...lists,
      {
        id: lists.length + 1,
        title: title,
        contents: contents,
        isDone: false,
      },
    ]);
    setTitle("");
    setContents("");
  }

  function changeDone(recieveId) {
    // console.log(recieveId);
    setList(
      lists.map(
        (list) =>
          list.id === recieveId
            ? { ...list, isDone: !list.isDone }
            : { ...list } //★
      )
    );
  }
  //   console.log(lists);
  function deleteHandler(id) {
    setList(lists.filter((list) => list.id !== id)); //한줄일때는 return 생략 가능
    console.log(id);
  }

  return (
    <div>
      <div className="wrap">
        <div className="input-section">
          <div className="input-wrap">
            <span>제목</span>
            <input
              className="input-title"
              value={title}
              //   placeholder="제목을 입력해주세요"
              // 인풋 이벤트로 들어온 입력 값을 title의 값으로 업데이트
              onChange={onChangeNameHandler} //★
            />
            <span>내용</span>
            <input
              className="onChangeNameHandler"
              value={contents}
              //   placeholder="내용을 입력해주세요"
              // 인풋 이벤트로 들어온 입력 값을 contents의 값으로 업데이트
              onChange={onChangeContentsHandler} //★
            />
          </div>
          <div className="add-button">
            <button onClick={addToDo}>추가하기</button>
          </div>
        </div>

        <div className="onChangeContentsHandler">
          <h2>Working..🔥</h2>
          <div className="list-section">
            {lists.map((list) => {
              if (list.isDone === false) {
                return (
                  <div className="list-box">
                    <div className="list-title">{list.title}</div>
                    <div className="list-contents">{list.contents}</div>
                    <div className="list-box-button">
                      <button onClick={() => deleteHandler(list.id)}>
                        삭제하기
                      </button>
                      {list.isDone ? (
                        <button onClick={() => changeDone(list.id)}>
                          취소
                        </button>
                      ) : (
                        <button onClick={() => changeDone(list.id)}>
                          완료
                        </button>
                      )}
                    </div>
                  </div>
                );
              }
            })}
          </div>

          <h2>Done..!✨</h2>
          <div className="list-section">
            {lists.map((list) => {
              if (list.isDone !== false) {
                return (
                  <div className="list-box">
                    <div className="list-title">{list.title}</div>
                    <div className="list-contents">{list.contents}</div>
                    <div className="list-box-button">
                      <button onClick={() => deleteHandler(list.id)}>
                        삭제하기
                      </button>
                      {list.isDone ? (
                        <button onClick={() => changeDone(list.id)}>
                          취소
                        </button>
                      ) : (
                        <button onClick={() => changeDone(list.id)}>
                          완료
                        </button>
                      )}
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
